export const Bookmark = ({ width = '20', height = '20', fill = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity={0.5}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.65079 17.7573C5.00212 18.3133 4 17.8524 4 16.9982V4.99971C4 3.34302 5.34315 2 7 2H13C14.6569 2 16 3.34302 16 4.99971V16.9982C16 17.8524 14.9979 18.3133 14.3492 17.7573L10 14.3157L5.65079 17.7573ZM14 14.8242V4.99971C14 4.44748 13.5523 3.99981 13 3.99981H7C6.44772 3.99981 6 4.44748 6 4.99971V14.8242L9.34921 12.2396C9.7237 11.9186 10.2763 11.9186 10.6508 12.2396L14 14.8242Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
